import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSliderChange } from '@angular/material/slider';
import { MatSnackBar } from '@angular/material/snack-bar';
// import { CollageItem } from '../image-collage.component';
import {CollageImageModel} from '../models/collage-image.model';

export interface CollageBorderData {
  image: CollageImageModel;
  target: HTMLElement;
}

export interface CollageBorderResult {
  image: CollageImageModel;
  target: HTMLElement;
  color: string;
  thickness: number;
  radius: number;
}

export interface CollageBorderColorData {
  image: CollageImageModel;
  target: HTMLElement;
  color: string;
}

export interface CollageBorderThicknessData {
  image: CollageImageModel;
  target: HTMLElement;
  thickness: number;
}

export interface CollageBorderRadiusData {
  image: CollageImageModel;
  target: HTMLElement;
  radius: number;
}

@Component({
  selector: 'app-collage-border',
  templateUrl: './collage-border.component.html',
  styleUrls: ['./collage-border.component.css']
})
export class CollageBorderComponent implements OnInit {

  onColorChanged: EventEmitter<CollageBorderColorData> = new EventEmitter<CollageBorderColorData>();
  onThicknessChanged: EventEmitter<CollageBorderThicknessData> = new EventEmitter<CollageBorderThicknessData>();
  onRadiusChanged: EventEmitter<CollageBorderRadiusData> = new EventEmitter<CollageBorderRadiusData>();

  color: string = '#FFFFFF';
  colorBackup: string = '';
  thickness: number = 0;
  thicknessBackup: number = 0;
  radius: number = 0;
  radiusBackup: number = 0;

  constructor(public dialogRef: MatDialogRef<CollageBorderComponent, CollageBorderResult>,
              @Inject(MAT_DIALOG_DATA) public data: CollageBorderData,
              private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.color = this.data.image.imageBorder.color;
    this.colorBackup = this.data.image.imageBorder.color;
    this.thickness = this.data.image.imageBorder.thickness;
    this.thicknessBackup = this.data.image.imageBorder.thickness;
    this.radius = this.data.image.imageBorder.radius;
    this.radiusBackup = this.data.image.imageBorder.radius;
  }

  handleColor({ value }: { value: string }): void {
    const { image, target } = this.data;
    this.color = value;
    image.imageBorder.color = value;

    const model: CollageBorderColorData = {
      image,
      target,
      color: value
    };

    this.onColorChanged.emit(model);
  }

  handleThickness(event: MatSliderChange): void {
    const { image, target } = this.data;
    this.thickness = event.value;
    image.imageBorder.thickness = event.value;

    const model: CollageBorderThicknessData = {
      image,
      target,
      thickness: event.value
    };

    this.onThicknessChanged.emit(model);
  }

  handleRadius(event: MatSliderChange): void {
    const { image, target } = this.data;
    this.radius = event.value;
    image.imageBorder.radius = event.value;

    const model: CollageBorderRadiusData = {
      image,
      target,
      radius: event.value
    };

    this.onRadiusChanged.emit(model);
  }

  cancel(): void {
    const { image, target } = this.data;

    const model: CollageBorderResult = {
      image,
      target,
      color: this.colorBackup,
      thickness: this.thicknessBackup,
      radius: this.radiusBackup
    };

    this.dialogRef.close(model);
  }

  apply(): void {
    const { image, target } = this.data;

    const model: CollageBorderResult = {
      image,
      target,
      color: this.color,
      thickness: this.thickness,
      radius: this.radius
    };

    this.dialogRef.close(model);
  }
}
